//BaseAnchorView
/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/1/14
 * Time: 4:44 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";


    var Bubble = require("ui/bubble/Bubble");
    var Button = require("ui/button/Button");
    var BaseAnchorView ={};

    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        BaseAnchorView = Marionette.ItemView.extend({
            withUIComponents: true,
            className:"anchor",

            initialize:function(options){
                this.anchorSelector = options.anchorSelector;
                this.featureId=options.featureId;
            },
            setPosition:function(){
                if(this.anchorSelector){
                    var element = $(this.anchorSelector);
                    var offset = element.offset();
                    this.$el.offset(offset);
                }
            },
            onClose: function () {
                if (this.uiComponents && this.uiComponents[this.bubbleComponentId]) {
                    this.uiComponents[this.bubbleComponentId].close();
                }
            },
            createAndRenderBubble: function (options) {
                var that=this;
                var bubbleOptions = {
                    targetControl: this.el,
                    showCloseButton: false,
                    permutation: Bubble.PERMUTATION.D,
                    theme: Bubble.THEME.LIGHT,
                    preventCloseOnBubbleMouseEnter: false
                };
                var bubbleButtonOptions = {
                    buttonCallback: function () {
                        LEPersonalization.navigateToFeatureEdit({
                            featureId:that.featureId
                        });
                    },
                    buttonPermutation: Button.PERMUTATION.BTN_PRIMARY
                };
                _.extend(bubbleOptions,options);
                if(bubbleOptions.buttonCaption){
                    _.extend(bubbleOptions,bubbleButtonOptions);
                }
                //var bubbleOptions= options;
                //var bubbleOptions = this._getBubbleOptions();
                this.uiComponents.host$.createAndRender(this.bubbleComponentId, {
                    type: Bubble,
                    options: bubbleOptions
                });
            }
//            onRender: function () {
//                var element=$(".lpview_queue_orb .queue_orb");
//                var offset=element.offset();
//                this.$el.offset(element.offset());
//                $(this.container).append(this.el);
//                this._createAndRenderBubble();
//            },
//            onClose:function(){
//                var i=0;
//            },
//            _createAndRenderBubble: function () {
//                var bubbleOptions = this._getBubbleOptions();
//                this.uiComponents.host$.createAndRender(this.bubbleComponentId, {
//                    type: Bubble,
//                    options: bubbleOptions
//                });
//            },
//            _getBubbleOptions: function () {
//                var bubbleOptions = {
//                    targetControl: this.el,
//                    showCloseButton: true,
//                    title : LE.translator.translate("LEPersonalization.webAgent.ACD.title"),
//                    text : LE.translator.translate("LEPersonalization.webAgent.ACD.text"),
//                    buttonCaption : LE.translator.translate("LEFramework.global.captions.edit"),
//                    buttonCallback : function(){},
//                    buttonPermutation : Button.PERMUTATION.BTN_PRIMARY,
//                    permutation : Bubble.PERMUTATION.F
//                };
//
//                return bubbleOptions;
//            }


        });
    });
    return BaseAnchorView;

});


